/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquareExcel: {
  name: 'square-excel';
  data: string;
} = {
  name: 'square-excel',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Zm18 0H4v16h16V4ZM9.445 8.168a1 1 0 0 1 1.387.277L12 10.197l1.168-1.752a1 1 0 0 1 1.664 1.11L13.202 12l1.63 2.445a1 1 0 0 1-1.664 1.11L12 13.803l-1.168 1.752a1 1 0 0 1-1.664-1.11L10.798 12l-1.63-2.445a1 1 0 0 1 .277-1.387Z" fill="currentColor"/></svg>`,
};
